/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_OtherInputs */

const en_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const fr_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

const it_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

const ru_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другой`)
};

const es_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const zh_cn2_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const ja_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の`)
};

const hi_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य`)
};

const pt_pt2_subtitle_export_keyword_other = /** @type {(inputs: Subtitle_Export_Keyword_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Subtitle_Export_Keyword_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_other = /** @type {((inputs?: Subtitle_Export_Keyword_OtherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_OtherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_other(inputs)
	if (locale === "de") return de_subtitle_export_keyword_other(inputs)
	if (locale === "it") return it_subtitle_export_keyword_other(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_other(inputs)
	if (locale === "es") return es_subtitle_export_keyword_other(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_other(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_other(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_other(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_other(inputs)
	return en_subtitle_export_keyword_other(inputs)
});